var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"headache-list-view"},_vm._l((_vm.items),function(item){return _c('div',{key:item.id},[_c('headache-item',{attrs:{"item":item},on:{"del-item":_vm.deleteItem}})],1)}),0)}
var staticRenderFns = []

export { render, staticRenderFns }